import { useGetBrokersUnprocessedEnrollmentsIdVbanDetails } from 'utils/web_api'
import { type BrokersVbanDetails } from 'utils/web_api.schemas'

import { type GrapeAPIErrorType } from './GrapeAPIError'

export interface VbanDetails {
  account_number: string
  routing_number: string
}

export function useGetVbanDetails ({
  enrollmentId,
  enabled = false,
}: {
  enrollmentId: string
  enabled?: boolean
}) {
  return useGetBrokersUnprocessedEnrollmentsIdVbanDetails<
    BrokersVbanDetails,
    GrapeAPIErrorType
  >(enrollmentId, {
    query: {
      enabled: enabled && !!enrollmentId,
      staleTime: 30000,
    },
  })
}
